const AccountSettings = () => {
	return <div>AccountSettings</div>;
};

export default AccountSettings;
